import Centrifuge from 'centrifuge'

class Ws {
  private CF: Centrifuge;
  private cb: (ctx: any) => any;
  constructor (url: string, cb: (ctx: any) => any, options = {}) {
    this.CF = new Centrifuge(url, options)
    this.cb = cb
    this.CF.on('connect', function(ctx) {
      // console.log('WS CONNECTED', ctx)
    })

    this.CF.on('disconnect', function(ctx) {
      // console.log('WS DISCONNECTED', ctx)
    })
  }

  public connect (token: string, uid: string) {
    this.setToken(token)
    this.CF.connect()
    this.subscribe('notify#' + uid)
  }
  public disconnect () {
    this.CF.disconnect()
  }
  private setToken (token: string) {
    this.CF.setToken(token)
  }
  private subscribe (ch: string) {
    const cb = this.cb
    this.CF.subscribe(ch, function(ctx) {
      cb(ctx.data)
    });
  }
}

export default Ws;